import { useEffect } from "react"
import qs from "query-string"
import { useCart } from "frontend/src/utils/useCart"

function useCartURLParams(search) {
  const { addMultiple, show, tryCoupon } = useCart()
  useEffect(() => {
    const params = qs.parse(search)
    if (typeof params.add !== "undefined") {
      let lineItems
      if (typeof params.add === "string") {
        lineItems = params.add.split(",")
      } else {
        lineItems = params.add.flatMap(val => val.split(","))
      }
      lineItems.forEach(lineItem => {
        const [id, quant] = lineItem.split(":")
        const [productID, variantID] = id.split(".")
        if (productID && variantID) {
          addMultiple({ productID, variantID }, quant ? Number(quant) : 1)
        }
      })
    }
    if (typeof params.coupon !== "undefined") {
      if (typeof params.coupon === "string") {
        tryCoupon(params.coupon)
      } else {
        params.coupon.forEach(coupon => tryCoupon(coupon))
      }
    }
    if (params.cart === "show") {
      show()
    }
  }, [addMultiple, search, show, tryCoupon])
}

export { useCartURLParams }
